import { ReactElement, useState } from 'react'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'

type Props = {
	/** Picked units that are in no carton. */
	unpacked: number,
	disabled: boolean,
	isCompleting: boolean,
	onConfirm: () => void,
}

/**
 * Finalizes the run, asking first when picked units are still on the bench.
 *
 * Units left out of every carton are not shipped and not shorted: their
 * fulfillment orders stay open for them. That is right when the packer meant
 * it and easy to miss when they didn't, so it is put to them before the run
 * closes rather than left to the warning on the Review step.
 */
export default function FinalizePickOrderButton( { unpacked, disabled, isCompleting, onConfirm }: Props ): ReactElement {
	const [ open, setOpen ] = useState( false )

	return (
		<>
			<Button
				variant="contained"
				color="success"
				onClick={() => ( unpacked > 0 ? setOpen( true ) : onConfirm() )}
				disabled={disabled}
				startIcon={isCompleting ? <CircularProgress size={16} color="inherit" /> : undefined}
			>
				Finalize
			</Button>
			<Dialog open={open} onClose={() => setOpen( false )} maxWidth="xs" fullWidth>
				<DialogTitle>
					Finalize with {unpacked} {unpacked === 1 ? 'unit' : 'units'} unpacked?
				</DialogTitle>
				<DialogContent>
					<DialogContentText>
						{unpacked === 1 ? 'It won’t ship, and its order stays' : 'They won’t ship, and their orders stay'}{' '}
						open for {unpacked === 1 ? 'it' : 'them'}. Put {unpacked === 1 ? 'it' : 'them'} back where{' '}
						{unpacked === 1 ? 'it' : 'they'} came from.
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button color="inherit" onClick={() => setOpen( false )}>Keep packing</Button>
					<Button
						color="success"
						variant="contained"
						onClick={() => {
							setOpen( false )
							onConfirm()
						}}
					>
						Finalize anyway
					</Button>
				</DialogActions>
			</Dialog>
		</>
	)
}
